import React, { Component } from "react";
import TopBarNav from '../components/topbar';
import Navigation from '../components/navigation';
import ViewClosedCases from '../components/closedcases'
class ClosedCases extends Component {
    render() {
        return (
          <>
          <div className='NewCasesWrap'>
             <TopBarNav/>
              <Navigation/>
              <ViewClosedCases />
          </div>
          
          </>
        )
    }
}
export default ClosedCases;